import classNames from 'classnames';
import {useFarm} from 'context/farmContext';
import {useWholesaler} from 'context/wholesaler';
import {useNavigate} from 'react-router-dom';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {
  FarmEvents,
  WholesalerEvent,
} from 'utilities/helper/googleAnalitics/EventHelper';
const CategoryBox = ({
  title,
  icon,
  disabled,
  type,
  appType,
}: ICategoryBoxProps) => {
  const navigate = useNavigate();
  const {updateType} = useFarm();
  const {updateTypePost} = useWholesaler();

  return (
    <>
      <div
        onClick={() => {
          if (disabled && appType === 'wholesaler') {
            navigate('/wholesaler/add-ad/purchase', {state: {from: 'buy'}});
            type && updateTypePost(type);
            type &&
              googleAnalyticsInstance.eventGoogleAnalytics(
                WholesalerEvent[type],
              );
          } else if (disabled && appType === 'farm') {
            navigate(`/${appType}/add-ad/info`);
            type && updateType(type);

            type &&
              googleAnalyticsInstance.eventGoogleAnalytics(FarmEvents[type]);
          }
        }}
        className={classNames(
          ' py-3 mt-3 shadow-md border rounded-md',
          disabled ? 'border-primary' : 'border-gray-3',
        )}
      >
        <div className="block mx-auto w-16">{icon}</div>
        <p className=" text-center mt-3">{title}</p>
      </div>
    </>
  );
};

export default CategoryBox;
